import { deleteBundleItem } from "../../api/inventoryService";

export const useDeleteBundleItem = (successCallback) => {
    const remove = async (item) => {
        try {
            await deleteBundleItem(item.id);
            successCallback(item);
        } catch (error) {
            console.error("Failed to delete bundle item:", error);
            throw error;
        }
    };

    return { remove };
};